// @flow
export const SPACING_NONE = '0';
export const SPACING_EXTRA_SMALL = '.25rem';
export const SPACING_SMALL = '.5rem';
export const SPACING_MEDIUM = '1rem';
export const SPACING_LARGE = '2rem';
export const SPACING_EXTRA_LARGE = '4rem';
export const SPACING_EXTRA_EXTRA_LARGE = '8rem';
export const SPACING_EXTRA_EXTRA_EXTRA_LARGE = '16rem';



// WEBPACK FOOTER //
// ./src/styles/spacing.js